"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("./_color"));
var ButtonLink = _styledComponents["default"].button.withConfig({
  displayName: "ButtonLink",
  componentId: "sc-11a80qp-0"
})(["color:", ";border:none;padding:0;font:inherit;cursor:pointer;font-size:", ";&:hover{text-decoration:underline;}"], _color["default"], function (props) {
  return props.linkFontSize;
});
var _default = ButtonLink;
exports["default"] = _default;
//# sourceMappingURL=ButtonLink.js.map